import { get } from './requests'

export const getRecommendationByHash = (hash, params = {}) =>
  get(['recommendations', hash], { params })
